import React, { useState } from "react";
import { Modal, Button, Form, Input, Col, Row } from "antd";
import { sendTeamInvite } from "@api/user/admin";
import {
  SuccessNotification,
  InfoNotification,
  ErrorNotification,
} from "@components";

const initialValues = {
  email: "",
};

const TeamInviteModal = ({ open, handleModalClick }) => {
  const [values, setValues] = useState(initialValues);
  const [processing, setProcessing] = useState(false);

  // Handle values change
  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // Handle invite send click
  const handleInviteSendClick = async (e) => {
    e.preventDefault();

    // Check if email is valid
    if (values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setProcessing(true);
      // Send invite
      sendTeamInvite(values)
        .then((res) => {
          if (res.status === 200) {
            // Success
            SuccessNotification(res.data.message);
            InfoNotification("🥴 Check mail spam if not found 🥴");
            handleModalClick();
            setProcessing(false);
          }
        })
        .catch((err) => {
          // Error
          ErrorNotification(err.response.data.type[0].message);
          console.log("TEAM_INVITE_ERROR", err);
          setProcessing(false);
        });
    } else {
      ErrorNotification("Please enter a valid email");
    }
  };

  return (
    <>
      <Modal
        title={
          <Col
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Row>
              <p
                style={{
                  fontSize: "1.5rem",
                  color: "#000",
                  marginLeft: "20%",
                }}
              >
                Invite a new team member
              </p>
            </Row>

            <Row>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#000",
                  marginLeft: "7%",
                }}
              >
                NOTE: Each team member will have their own workspace
              </p>
            </Row>
          </Col>
        }
        visible={open}
        onOk={handleModalClick}
        closable={false}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleInviteSendClick}
            loading={processing}
          >
            Send
          </Button>,
        ]}
      >
        <Form
          labelCol={{
            span: 5,
          }}
          wrapperCol={{
            span: 16,
          }}
        >
          {/* Email */}
          <Form.Item label="Email">
            <Input
              name="email"
              placeholder="Enter email"
              onChange={handleChange}
              value={values.email}
              rules={[{ type: "email" }]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default TeamInviteModal;
